import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import useCart from '@/public/hooks/use-cart'
import { selectVerified } from '@/public/redux/recaptchaSlice'
import { numberToCurrency } from '@/shared/helpers/String'
import { setLoading, handleRemove } from '@/public/redux/cartSlice'
import Timer from '@/public/cart/Timer'
import { accessToken } from '../../shared/helpers/CSRF'

export default function VirtualVisitCartItem({
  data: item = null,
  virtualVisit,
  expiresAtTimestamp,
  showTimer = true,
}) {
  const verified = useSelector(selectVerified)
  const dispatch = useDispatch()
  const { cart, mutate } = useCart()

  const handleRemoveClick = (e) => {
    e.stopPropagation()

    dispatch(setLoading(true))
    handleRemove(accessToken, cart, item, mutate, dispatch, 1)
  }

  const navigateToCancelPage = (e) => {
    handleRemoveClick(e)
    const cancelPath = virtualVisit?.new_url
    window.location.href = cancelPath
  }

  return !item ? '' : (
    <div>
      {showTimer && (
        <Timer
          expiresAtTimestamp={expiresAtTimestamp}
          data={{ ...virtualVisit }}
        />
      )}
      <div className="cart-list-item">

        {
          /*
           * BEGIN DESKTOP
           */
        }
        <div className="cart-list-item-desktop d-none d-md-flex flex-wrap w-100">
          <div className="cart-list-item-image">
            <a href={item.permalink} className="disabled">
              <img src={item.featured_image_url} alt={item.featured_image_alt_text} />
            </a>
          </div>

          <div className="cart-list-item-details">
            <div className="cart-list-item-details-name h4">
              <a href={item.permalink} className="text-decoration-none d-block disabled title-color">
                {item.name}
              </a>
            </div>
            <div className="cart-list-item-details-desc">
              <p className="my-0 py-0">
                Date:
                {' '}
                <b>{virtualVisit?.date}</b>
              </p>
              <p className="my-0 py-0">
                Time:
                {' '}
                <b>
                  {virtualVisit?.start_time}
                  {' '}
                  -
                  {' '}
                  {virtualVisit?.end_time}
                </b>
                {' '}
                {virtualVisit?.time_zone}
              </p>
              <p className="my-0 py-0">
                with
                {' '}
                <b>{virtualVisit?.doctor}</b>
                ,
                {' '}
                {virtualVisit?.credentials}
              </p>
              <p className="my-0 py-0">
                <button
                  className="btn btn-link text-end"
                  type="button"
                  onClick={(e) => navigateToCancelPage(e)}
                >
                  Change day/time
                </button>
              </p>
            </div>
          </div>

          <div className="cart-list-item-end">
            <div className="cart-list-item-price h5">
              <div>
                <span>{numberToCurrency(item.price)}</span>
              </div>
            </div>
            <button
              className="btn btn-link text-end"
              type="button"
              disabled={!verified}
              onClick={(e) => handleRemoveClick(e)}
            >
              Remove
            </button>
          </div>
        </div>
        {
          /*
           * END DESKTOP
           */
        }
        {
          /*
           * BEGIN MOBILE
           */
        }
        <div className="cart-list-item-mobile d-flex d-md-none">
          <div className="cart-list-item-image">
            <div>
              <a href={item.permalink} className="disabled">
                <img src={item.featured_image_url} alt={item.featured_image_alt_text} />
              </a>
            </div>
            <div className="cart-list-item-details">
              <div className="cart-list-item-details-name h5">
                <a href={item.permalink} className="text-decoration-none d-block disabled title-color">
                  {item.name}
                </a>
                <span>{numberToCurrency(item.price)}</span>
              </div>
            </div>
          </div>
          <div className="cart-list-item-details-desc">
            <p className="my-0 py-0">
              Date:
              <b>{virtualVisit?.date}</b>
            </p>
            <p className="my-0 py-0">
              Time:
              <b>
                {virtualVisit?.start_time}
                {' '}
                -
                {' '}
                {virtualVisit?.end_time}
              </b>
              {' '}
              {virtualVisit?.time_zone}
            </p>
            <p className="my-0 py-0">
              Doctor:
              <b>{virtualVisit?.doctor}</b>
              ,
              {virtualVisit?.title}
            </p>
            <p className="my-0 py-0">
              <button
                className="btn btn-link text-end"
                type="button"
                onClick={(e) => navigateToCancelPage(e)}
              >
                Change day/time
              </button>
            </p>
          </div>
          <div className="cart-list-item-end" />
          <button
            className="btn btn-link text-end"
            type="button"
            disabled={!verified}
            onClick={(e) => handleRemoveClick(e)}
          >
            Remove
          </button>
        </div>
        {
          /*
           * END MOBILE
           */
        }

      </div>
    </div>
  )
}
